import React, { useState, useEffect } from 'react';
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "./firebase-config";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './App.css'
import * as ReactBootStrap from "react-bootstrap";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Login from './components/login.component'
import Testing from './components/testing.component'
import Admin from './components/panel.component'
import Home from './components/home.component'
import SignUp from './components/signup.component'
import ForgotPassword from './components/ForgotPassword.component'
// function App(props) {
const App = props => {
  console.log(process.env.REACT_APP_BACKEND)
  let location;
  location = window.location.pathname;
  location = location.split("/");
  const [user, setUser] = useState({});
  useEffect(() => {
    onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
  }, [])
  let SignInBtn;
  let SignUpBtn;
  let SignOutBtn;
  let SignInClass;
  let SignUpClass;
  let mainBar;
  let optionsLogged;
  const logout = async () => {
    await signOut(auth);
    window.location = "/"
  };
  if (location[1] === "/sign-in") {
    SignInClass = "active";
  }
  if (location[1] === "/sign-up") {
    SignUpClass = "active";
  }
  if (user != null) {
    SignInBtn = "";
    SignUpBtn = "";
    SignOutBtn = <ReactBootStrap.Nav.Link onClick={() => { logout(); }} >Sign Out </ReactBootStrap.Nav.Link>;
    optionsLogged = <ReactBootStrap.Nav className="me-auto">
      <ReactBootStrap.Nav.Link href="#features">Features</ReactBootStrap.Nav.Link>
      <ReactBootStrap.Nav.Link href="#pricing">Pricing</ReactBootStrap.Nav.Link>
      <ReactBootStrap.NavDropdown title="Dropdown" id="collasible-nav-dropdown">
        <ReactBootStrap.NavDropdown.Item href="#action/3.1">Action</ReactBootStrap.NavDropdown.Item>
        <ReactBootStrap.NavDropdown.Item href="#action/3.2">Another action</ReactBootStrap.NavDropdown.Item>
        <ReactBootStrap.NavDropdown.Item href="#action/3.3">Something</ReactBootStrap.NavDropdown.Item>
        <ReactBootStrap.NavDropdown.Divider />
        <ReactBootStrap.NavDropdown.Item href="#action/3.4">Separated link</ReactBootStrap.NavDropdown.Item>
      </ReactBootStrap.NavDropdown></ReactBootStrap.Nav>;
    optionsLogged = <ReactBootStrap.Nav className="me-auto"></ReactBootStrap.Nav>;
  } else {
    SignInBtn = <ReactBootStrap.Nav.Link to='sign-in' href={'/sign-in'} className={SignInClass}>Sign In</ReactBootStrap.Nav.Link>;
    SignUpBtn = <ReactBootStrap.Nav.Link to='sign-up' href={"/sign-up"} className={SignUpClass}>Sign Up</ReactBootStrap.Nav.Link>;
    SignOutBtn = "";
    optionsLogged = <ReactBootStrap.Nav className="me-auto"></ReactBootStrap.Nav>;
  }
  mainBar = <ReactBootStrap.Navbar collapseOnSelect expand="lg" bg="light" variant="light">
    <ReactBootStrap.Container style={{ padding: 0 }}>
      <div style={{padding: "0 10px", width: "100%"}}>
        <ReactBootStrap.Navbar.Brand href="/home"><b>Sportscampament</b></ReactBootStrap.Navbar.Brand>
        <ReactBootStrap.Navbar.Toggle aria-controls="responsive-navbar-nav" />
      </div>
      <ReactBootStrap.Navbar.Collapse id="responsive-navbar-nav">
        {optionsLogged}
        <ReactBootStrap.Nav style={{ backgroundColor: "#cecece" }}>
          {SignInBtn}
          {SignUpBtn}
          {SignOutBtn}
          <ReactBootStrap.Nav.Link to='admin' href={'/admin'} ><b>{(user != null) ? user.email : ""}</b></ReactBootStrap.Nav.Link>
        </ReactBootStrap.Nav>
      </ReactBootStrap.Navbar.Collapse>
    </ReactBootStrap.Container>
  </ReactBootStrap.Navbar>;
  if (location[1] === "admin") {
    mainBar = "";
  }
  return (

    <div className="App">
      {/* <nav className="navbar navbar-expand-lg navbar-light fixed-top">
          <div className="container">
            <Link className="navbar-brand" to={'/home'}>
              <b>Sports</b> Campament
            </Link>
            <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
              <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                  <Link className="nav-link" to={'/sign-in'}>
                    Login
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={'/sign-up'}>
                    Sign up
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav> */}
      {mainBar}
      <Router>
        <Routes>
          <Route exact path="/" element={<Login />} />
          <Route exact path="/home" element={<Login />} />
          <Route exact path="/sign-in" element={<Login />} />
          <Route exact path="/sign-up" element={<SignUp />} />
          <Route exact path="/ForgotPassword" element={<ForgotPassword />} />
          <Route exact path="/admin" element={<Admin />} />
          <Route exact path="/admin/:type" element={<Admin />} />
          <Route exact path="/testing" element={<Testing />} />
        </Routes>
      </Router>
    </div>
  )
}

export default App;